import { jsx as _jsx } from "react/jsx-runtime";
// a provider for the chatbot service
// this is a singleton service that is used to communicate with the chatbot
import { createContext, useContext, useMemo } from "react";
import ChatbotService from "./ChatbotService";
var ChatbotContext = createContext(null);
export var ChatbotServiceProvider = function (_a) {
    var endpoint = _a.endpoint, token = _a.token, children = _a.children;
    var service = useMemo(function () { return new ChatbotService({ endpoint: endpoint, token: token }); }, [endpoint, token]);
    return (_jsx(ChatbotContext.Provider, { value: service, children: children }));
};
export var useChatbotService = function () {
    var context = useContext(ChatbotContext);
    if (!context) {
        throw new Error("useChatbot must be used within a ChatbotProvider");
    }
    return context;
};
